/* export const formatBytes = (bytes: number, decimals = 2) => {
	if (!+bytes) return '0 Bytes';

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
}; */

export const formatBytes = (bytes: number) => {
	const units = ['bytes', 'KB', 'MB', 'GB'];
	let l = 0;
	let n = Number(bytes);

	// eslint-disable-next-line no-plusplus
	while (n >= 1024 && ++l) {
		n /= 1024;
	}

	return `${n.toFixed(n < 10 && l > 0 ? 1 : 0)} ${units[l]}`;
};
